/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: sMdpLWyxbzDCruwMRffW2m
// Component: ZuA2HO8MLBhh

import { viewPageLink } from "@/modules/search/functions/viewPageLink";
import { tomanSign } from '@/common/components/atom/toman/toman';
import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import Avatar from "../../Avatar"; // plasmic-import: 3i84rYjQRrs4/component
import Chip from "../../Chip"; // plasmic-import: 1bFBcAoH0lNN/component
import LineClamp from "../../LineClamp"; // plasmic-import: fa_t7ELXcm5k/component
import TagsRow from "../../TagsRow"; // plasmic-import: QiKny2-oAX-B/component
import Dialog from "../../Dialog"; // plasmic-import: FJiI2-N1is_F/component
import { ApiRequest } from "@/common/fragment/components/api-request"; // plasmic-import: vW4UBuHCFshJ/codeComponent
import Button from "../../Button"; // plasmic-import: oVzoHzMf1TLl/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: sMdpLWyxbzDCruwMRffW2m/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: sMdpLWyxbzDCruwMRffW2m/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "../fragment_design_system/plasmic.module.css"; // plasmic-import: sMdpLWyxbzDCruwMRffW2m/projectcss
import sty from "./PlasmicProductCard.module.css"; // plasmic-import: ZuA2HO8MLBhh/css

import Icon41Icon from "./icons/PlasmicIcon__Icon41"; // plasmic-import: l0_vYhehuk4T/icon
import Icon7Icon from "./icons/PlasmicIcon__Icon7"; // plasmic-import: TnnJDmwgAOL7/icon
import Icon2Icon from "./icons/PlasmicIcon__Icon2"; // plasmic-import: I0wBVQs9owLc/icon
import LocationIcon from "../fragment_icons/icons/PlasmicIcon__Location"; // plasmic-import: 9zdEG9CdGbdC/icon
import MoneyIcon from "../fragment_icons/icons/PlasmicIcon__Money"; // plasmic-import: 4D7uZNf6OjbV/icon
import SmileIcon from "../fragment_icons/icons/PlasmicIcon__Smile"; // plasmic-import: J8ozh55UiWsA/icon
import CalendarIcon from "../fragment_icons/icons/PlasmicIcon__Calendar"; // plasmic-import: e2zWN9c_lxv7/icon
import ClockIcon from "../fragment_icons/icons/PlasmicIcon__Clock"; // plasmic-import: rW7v27ONOoUe/icon
import InfoIcon from "../fragment_icons/icons/PlasmicIcon__Info"; // plasmic-import: 7Dhq6fgU-utK/icon
import ChevronRightIcon from "../fragment_icons/icons/PlasmicIcon__ChevronRight"; // plasmic-import: GHdF3hS-oP_3/icon
import ChevronLeftIcon from "../fragment_icons/icons/PlasmicIcon__ChevronLeft"; // plasmic-import: r9Upp9NbiZkf/icon
import { compactTopTitle } from "@/modules/search/components/productCard/topTitle";

createPlasmicElementProxy;

export type PlasmicProductCard__VariantMembers = {
  _5StarRatingMode3: "_5StarA";
  externalBookDesign: "externalBookDesign";
  isSingleCard: "isSingleCard";
};
export type PlasmicProductCard__VariantsArgs = {
  _5StarRatingMode3?: SingleChoiceArg<"_5StarA">;
  externalBookDesign?: SingleBooleanChoiceArg<"externalBookDesign">;
  isSingleCard?: SingleBooleanChoiceArg<"isSingleCard">;
};
type VariantPropType = keyof PlasmicProductCard__VariantsArgs;
export const PlasmicProductCard__VariantProps = new Array<VariantPropType>(
  "_5StarRatingMode3",
  "externalBookDesign",
  "isSingleCard"
);

export type PlasmicProductCard__ArgsType = {
  badges?: any;
  actionButtons?: any;
  title?: string;
  subTitle?: string;
  address?: string;
  price?: React.ReactNode;
  avatarSrc?: string;
  rateCount?: number;
  satisfactionPercent?: number;
  avatarVerifiedTick?: boolean;
  avatarRingColor?: string;
  url?: any;
  avatarAltText?: string;
  eventTrigger?: (elementName: string, elementContent: string) => void;
  topBadge?: any;
  externalLinkTitle?: string;
  classificationTitleApi?: string;
  searchCardId?: string;
  debugModeResult?: any;
  slug?: string;
  centers?: any;
  recordType?: string;
  keywordTags?: any;
  certificates?: any;
};
type ArgPropType = keyof PlasmicProductCard__ArgsType;
export const PlasmicProductCard__ArgProps = new Array<ArgPropType>(
  "badges",
  "actionButtons",
  "title",
  "subTitle",
  "address",
  "price",
  "avatarSrc",
  "rateCount",
  "satisfactionPercent",
  "avatarVerifiedTick",
  "avatarRingColor",
  "url",
  "avatarAltText",
  "eventTrigger",
  "topBadge",
  "externalLinkTitle",
  "classificationTitleApi",
  "searchCardId",
  "debugModeResult",
  "slug",
  "centers",
  "recordType",
  "keywordTags",
  "certificates"
);

export type PlasmicProductCard__OverridesType = {
  root?: Flex__<"div">;
  avatar?: Flex__<typeof Avatar>;
  classificationTitle?: Flex__<"span">;
  badgesChip2?: Flex__<typeof Chip>;
  cardTitle?: Flex__<"h2">;
  linkSubtitle?: Flex__<"a"> & Partial<LinkProps>;
  cardSubtitle?: Flex__<"span">;
  linkTagsOfExpertise?: Flex__<"a"> & Partial<LinkProps>;
  linkTags?: Flex__<"a"> & Partial<LinkProps>;
  cardAddressRow?: Flex__<"span">;
  cardPrice?: Flex__<"span">;
  dialog?: Flex__<typeof Dialog>;
  badgesChip?: Flex__<typeof Chip>;
  actionButtonsContainer?: Flex__<"div">;
  rismanActionBtn?: Flex__<typeof ApiRequest>;
  cardActionSduiV2UiRequest?: Flex__<typeof ApiRequest>;
  oldActionButtonsHorizontalStack?: Flex__<"div">;
  getProviderFromSlugApiRequest?: Flex__<typeof ApiRequest>;
  availabilityStatus?: Flex__<typeof ApiRequest>;
};

export interface DefaultProductCardProps {
  badges?: any;
  actionButtons?: any;
  title?: string;
  subTitle?: string;
  address?: string;
  price?: React.ReactNode;
  avatarSrc?: string;
  rateCount?: number;
  satisfactionPercent?: number;
  avatarVerifiedTick?: boolean;
  avatarRingColor?: string;
  url?: any;
  avatarAltText?: string;
  eventTrigger?: (elementName: string, elementContent: string) => void;
  topBadge?: any;
  externalLinkTitle?: string;
  classificationTitleApi?: string;
  searchCardId?: string;
  debugModeResult?: any;
  slug?: string;
  centers?: any;
  recordType?: string;
  keywordTags?: any;
  certificates?: any;
  _5StarRatingMode3?: SingleChoiceArg<"_5StarA">;
  externalBookDesign?: SingleBooleanChoiceArg<"externalBookDesign">;
  isSingleCard?: SingleBooleanChoiceArg<"isSingleCard">;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicProductCard__RenderFunc(props: {
  variants: PlasmicProductCard__VariantsArgs;
  args: PlasmicProductCard__ArgsType;
  overrides: PlasmicProductCard__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          avatarVerifiedTick: false
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "dialog[].open",
        type: "private",
        variableType: "boolean"
      },
      {
        path: "_5StarRatingMode3",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props._5StarRatingMode3
      },
      {
        path: "externalBookDesign",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props.externalBookDesign
      },
      {
        path: "actionButtonsVisibility",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => true
      },
      {
        path: "cardActionSduiV2UiRequest.data",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        refName: "cardActionSduiV2UiRequest"
      },
      {
        path: "cardActionSduiV2UiRequest.error",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        refName: "cardActionSduiV2UiRequest"
      },
      {
        path: "cardActionSduiV2UiRequest.loading",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        refName: "cardActionSduiV2UiRequest"
      },
      {
        path: "getProviderFromSlugApiRequest[].data",
        type: "private",
        variableType: "object",

        refName: "getProviderFromSlugApiRequest"
      },
      {
        path: "getProviderFromSlugApiRequest[].error",
        type: "private",
        variableType: "object",

        refName: "getProviderFromSlugApiRequest"
      },
      {
        path: "getProviderFromSlugApiRequest[].loading",
        type: "private",
        variableType: "boolean",

        refName: "getProviderFromSlugApiRequest"
      },
      {
        path: "availabilityStatus[].data",
        type: "private",
        variableType: "object",

        refName: "availabilityStatus"
      },
      {
        path: "availabilityStatus[].error",
        type: "private",
        variableType: "object",

        refName: "availabilityStatus"
      },
      {
        path: "availabilityStatus[].loading",
        type: "private",
        variableType: "boolean",

        refName: "availabilityStatus"
      },
      {
        path: "isSingleCard",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props.isSingleCard
      },
      {
        path: "rismanActionBtn.data",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        refName: "rismanActionBtn"
      },
      {
        path: "rismanActionBtn.error",
        type: "private",
        variableType: "object",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        refName: "rismanActionBtn"
      },
      {
        path: "rismanActionBtn.loading",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        refName: "rismanActionBtn"
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        {
          [sty.root_5StarRatingMode3__5StarA]: hasVariant(
            $state,
            "_5StarRatingMode3",
            "_5StarA"
          ),
          [sty.rootexternalBookDesign]: hasVariant(
            $state,
            "externalBookDesign",
            "externalBookDesign"
          ),
          [sty.rootisSingleCard]: hasVariant(
            $state,
            "isSingleCard",
            "isSingleCard"
          )
        }
      )}
      dir={"rtl"}
    >
      {(() => {
        try {
          return $props.topBadge[0].title !== undefined;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return false;
          }
          throw e;
        }
      })() ? (
        <div
          className={classNames(projectcss.all, sty.freeBox__bcNgL, {
            [sty.freeBoxisSingleCard__bcNgL5YIx5]: hasVariant(
              $state,
              "isSingleCard",
              "isSingleCard"
            )
          })}
          onClick={async event => {
            const $steps = {};
          }}
        >
          {(() => {
            try {
              return $props.topBadge[0].title !== undefined;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return false;
              }
              throw e;
            }
          })() ? (
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__hKulC
              )}
            >
              <React.Fragment>
                {(() => {
                  try {
                    return $props.topBadge[0].title;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return " ";
                    }
                    throw e;
                  }
                })()}
              </React.Fragment>
            </div>
          ) : null}
          {(() => {
            try {
              return $props.topBadge[0].title !== undefined;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return false;
              }
              throw e;
            }
          })() ? (
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__hUA
              )}
            >
              {"    "}
            </div>
          ) : null}
        </div>
      ) : null}
      <div
        className={classNames(projectcss.all, sty.freeBox__wJlKm, {
          [sty.freeBoxexternalBookDesign__wJlKmHqYe]: hasVariant(
            $state,
            "externalBookDesign",
            "externalBookDesign"
          ),
          [sty.freeBoxisSingleCard__wJlKm5YIx5]: hasVariant(
            $state,
            "isSingleCard",
            "isSingleCard"
          )
        })}
      >
        {(() => {
          try {
            return !/^\/s\/([a-zA-Z0-9_-]+(?: [a-zA-Z0-9_-]+)*)\/([a-zA-Z0-9_-]+(?: [a-zA-Z0-9_-]+)*)\/$/.test(
              $props.url.destination
            );
          } catch (e) {
            if (
              e instanceof TypeError ||
              e?.plasmicType === "PlasmicUndefinedDataError"
            ) {
              return true;
            }
            throw e;
          }
        })() ? (
          <div
            className={classNames(projectcss.all, sty.freeBox__vbw0E, {
              [sty.freeBoxisSingleCard__vbw0E5YIx5]: hasVariant(
                $state,
                "isSingleCard",
                "isSingleCard"
              )
            })}
          >
            {(() => {
              try {
                return !!$props.avatarSrc;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return false;
                }
                throw e;
              }
            })() ? (
              <PlasmicLink__
                className={classNames(
                  projectcss.all,
                  projectcss.a,
                  sty.link__hyRw8
                )}
                component={Link}
                href={(() => {
                  try {
                    return $props.url?.destination.startsWith("/center/https")
                      ? $props.url?.destination.slice(8, -1)
                      : $props.url?.destination;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return undefined;
                    }
                    throw e;
                  }
                })()}
                onClick={async event => {
                  const $steps = {};

                  $steps["runEventTrigger"] = true
                    ? (() => {
                        const actionArgs = {
                          eventRef: $props["eventTrigger"],
                          args: ["avatar"]
                        };
                        return (({ eventRef, args }) => {
                          return eventRef?.(...(args ?? []));
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["runEventTrigger"] != null &&
                    typeof $steps["runEventTrigger"] === "object" &&
                    typeof $steps["runEventTrigger"].then === "function"
                  ) {
                    $steps["runEventTrigger"] = await $steps["runEventTrigger"];
                  }
                }}
                platform={"nextjs"}
                target={(() => {
                  try {
                    return $props.url?.openInNewTab;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return undefined;
                    }
                    throw e;
                  }
                })()}
                title={(() => {
                  try {
                    return $props.url?.title;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return undefined;
                    }
                    throw e;
                  }
                })()}
              >
                <Avatar
                  data-plasmic-name={"avatar"}
                  data-plasmic-override={overrides.avatar}
                  alt={(() => {
                    try {
                      return $props.avatarAltText;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  badge={(() => {
                    try {
                      return $props.avatarVerifiedTick ? "check" : "";
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return [];
                      }
                      throw e;
                    }
                  })()}
                  className={classNames("__wab_instance", sty.avatar)}
                  ring={(() => {
                    try {
                      return $props.avatarRingColor;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return [];
                      }
                      throw e;
                    }
                  })()}
                  src={(() => {
                    try {
                      return $props.avatarSrc;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                />
              </PlasmicLink__>
            ) : null}
            {(() => {
              try {
                return (
                  $state.cardActionSduiV2UiRequest?.data
                    ?.search_result_card_ui[0]?.data?.category_name?.length > 2
                );
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return false;
                }
                throw e;
              }
            })() ? (
              <span
                data-plasmic-name={"classificationTitle"}
                data-plasmic-override={overrides.classificationTitle}
                className={classNames(
                  projectcss.all,
                  projectcss.span,
                  sty.classificationTitle,
                  {
                    [sty.classificationTitle_5StarRatingMode3__5StarA]:
                      hasVariant($state, "_5StarRatingMode3", "_5StarA"),
                    [sty.classificationTitleexternalBookDesign]: hasVariant(
                      $state,
                      "externalBookDesign",
                      "externalBookDesign"
                    )
                  }
                )}
              >
                <Chip
                  data-plasmic-name={"badgesChip2"}
                  data-plasmic-override={overrides.badgesChip2}
                  children={null}
                  className={classNames("__wab_instance", sty.badgesChip2)}
                  color={"gray"}
                  content={(() => {
                    try {
                      return $state.cardActionSduiV2UiRequest.data
                        .search_result_card_ui[0].data.category_name;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  size={"xSmall"}
                  slot={null}
                />
              </span>
            ) : null}
          </div>
        ) : null}
        <div className={classNames(projectcss.all, sty.freeBox__uwhEa)}>
          <div className={classNames(projectcss.all, sty.freeBox__d8Dss)}>
            {(() => {
              try {
                return $props.title ? true : false;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return true;
                }
                throw e;
              }
            })() ? (
              <PlasmicLink__
                className={classNames(
                  projectcss.all,
                  projectcss.a,
                  sty.link__iYnI7
                )}
                component={Link}
                href={(() => {
                  try {
                    return $props.url?.destination.startsWith("/center/https")
                      ? $props.url?.destination.slice(8, -1)
                      : $props.url?.destination;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return undefined;
                    }
                    throw e;
                  }
                })()}
                onClick={async event => {
                  const $steps = {};

                  $steps["runEventTrigger"] = true
                    ? (() => {
                        const actionArgs = {
                          eventRef: $props["eventTrigger"],
                          args: [
                            "title",
                            (() => {
                              try {
                                return $props.title;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return undefined;
                                }
                                throw e;
                              }
                            })()
                          ]
                        };
                        return (({ eventRef, args }) => {
                          return eventRef?.(...(args ?? []));
                        })?.apply(null, [actionArgs]);
                      })()
                    : undefined;
                  if (
                    $steps["runEventTrigger"] != null &&
                    typeof $steps["runEventTrigger"] === "object" &&
                    typeof $steps["runEventTrigger"].then === "function"
                  ) {
                    $steps["runEventTrigger"] = await $steps["runEventTrigger"];
                  }
                }}
                platform={"nextjs"}
                target={(() => {
                  try {
                    return $props.url?.openInNewTab;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return undefined;
                    }
                    throw e;
                  }
                })()}
                title={(() => {
                  try {
                    return $props.url?.title;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return undefined;
                    }
                    throw e;
                  }
                })()}
              >
                <LineClamp
                  className={classNames(
                    "__wab_instance",
                    sty.lineClamp___342Ax
                  )}
                  numberOfLines={(() => {
                    try {
                      return $props.searchCardId.startsWith("center") ? 2 : 1;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return 1;
                      }
                      throw e;
                    }
                  })()}
                >
                  <h2
                    data-plasmic-name={"cardTitle"}
                    data-plasmic-override={overrides.cardTitle}
                    className={classNames(
                      projectcss.all,
                      projectcss.h2,
                      projectcss.__wab_text,
                      sty.cardTitle,
                      {
                        [sty.cardTitleisSingleCard]: hasVariant(
                          $state,
                          "isSingleCard",
                          "isSingleCard"
                        )
                      }
                    )}
                  >
                    <React.Fragment>
                      {(() => {
                        try {
                          return $props.title;
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return "\u0639\u0646\u0648\u0627\u0646 \u067e\u06cc\u0634 \u0641\u0631\u0636 \u0646\u0627\u0645 \u06a9\u0627\u0631\u0628\u0631 \u06cc\u0627 \u0646\u062a\u06cc\u062c\u0647";
                          }
                          throw e;
                        }
                      })()}
                    </React.Fragment>
                  </h2>
                </LineClamp>
              </PlasmicLink__>
            ) : null}
            {false ? (
              <PlasmicLink__
                className={classNames(
                  projectcss.all,
                  projectcss.a,
                  sty.link__jKdVb
                )}
                component={Link}
                href={(() => {
                  try {
                    return (() => {
                      const encodedUrl = window.location.href
                        .replace(/#/g, "%23")
                        .replace(/&/g, "%26")
                        .replace(/:/g, "%3A")
                        .replace(/\//g, "%2F")
                        .replace(/\?/g, "%3F");
                      const reportUrl = `https://apigw.paziresh24.com/v1/hami/report?searchCardId=${$props.searchCardId}&name=${$props.title}&url=${encodedUrl}`;
                      return reportUrl;
                    })();
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return "https://apigw.paziresh24.com/v1/hami/report?name=xxxx&title=xxxx&adress=xxxx&url=xxxx";
                    }
                    throw e;
                  }
                })()}
                platform={"nextjs"}
                target={"_blank"}
              >
                <Icon41Icon
                  className={classNames(projectcss.all, sty.svg__mb4OC)}
                  role={"img"}
                />
              </PlasmicLink__>
            ) : null}
          </div>
          {(() => {
            try {
              return (
                $props.title &&
                !(
                  $props.keywordTags &&
                  Object.keys($props.keywordTags.user_priority_1).length > 0
                )
              );
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return true;
              }
              throw e;
            }
          })() ? (
            <PlasmicLink__
              data-plasmic-name={"linkSubtitle"}
              data-plasmic-override={overrides.linkSubtitle}
              className={classNames(
                projectcss.all,
                projectcss.a,
                sty.linkSubtitle
              )}
              component={Link}
              href={(() => {
                try {
                  return $props.url?.destination.startsWith("/center/https")
                    ? $props.url?.destination.slice(8, -1)
                    : $props.url?.destination;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
              onClick={async event => {
                const $steps = {};

                $steps["runEventTrigger"] = true
                  ? (() => {
                      const actionArgs = {
                        eventRef: $props["eventTrigger"],
                        args: [
                          "subTitle",
                          (() => {
                            try {
                              return $props.subTitle;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()
                        ]
                      };
                      return (({ eventRef, args }) => {
                        return eventRef?.(...(args ?? []));
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["runEventTrigger"] != null &&
                  typeof $steps["runEventTrigger"] === "object" &&
                  typeof $steps["runEventTrigger"].then === "function"
                ) {
                  $steps["runEventTrigger"] = await $steps["runEventTrigger"];
                }
              }}
              platform={"nextjs"}
              target={(() => {
                try {
                  return $props.url?.openInNewTab;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
              title={(() => {
                try {
                  return $props.url?.title;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
            >
              {(() => {
                try {
                  return !!$props.subTitle;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return false;
                  }
                  throw e;
                }
              })() ? (
                <LineClamp
                  className={classNames("__wab_instance", sty.lineClamp__lmqY, {
                    [sty.lineClampexternalBookDesign__lmqYHqYe]: hasVariant(
                      $state,
                      "externalBookDesign",
                      "externalBookDesign"
                    )
                  })}
                  numberOfLines={(() => {
                    try {
                      return !$props.rateCount ? 2 : 1;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return 1;
                      }
                      throw e;
                    }
                  })()}
                >
                  <span
                    data-plasmic-name={"cardSubtitle"}
                    data-plasmic-override={overrides.cardSubtitle}
                    className={classNames(
                      projectcss.all,
                      projectcss.span,
                      projectcss.__wab_text,
                      sty.cardSubtitle,
                      {
                        [sty.cardSubtitle_5StarRatingMode3__5StarA]: hasVariant(
                          $state,
                          "_5StarRatingMode3",
                          "_5StarA"
                        ),
                        [sty.cardSubtitleexternalBookDesign]: hasVariant(
                          $state,
                          "externalBookDesign",
                          "externalBookDesign"
                        )
                      }
                    )}
                  >
                    <React.Fragment>
                      {(() => {
                        try {
                          return $props.subTitle.replace(
                            /([^،])،(?!\s)([^،])/g,
                            "$1، $2"
                          );
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return " ";
                          }
                          throw e;
                        }
                      })()}
                    </React.Fragment>
                  </span>
                </LineClamp>
              ) : null}
            </PlasmicLink__>
          ) : null}
          {(() => {
            try {
              return (
                $props.title &&
                $props.keywordTags &&
                Object.keys($props.keywordTags.user_priority_1).length > 0
              );
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return false;
              }
              throw e;
            }
          })() ? (
            <PlasmicLink__
              data-plasmic-name={"linkTagsOfExpertise"}
              data-plasmic-override={overrides.linkTagsOfExpertise}
              className={classNames(
                projectcss.all,
                projectcss.a,
                sty.linkTagsOfExpertise
              )}
              component={Link}
              href={(() => {
                try {
                  return $props.url?.destination.startsWith("/center/https")
                    ? $props.url?.destination.slice(8, -1)
                    : $props.url?.destination;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
              onClick={async event => {
                const $steps = {};

                $steps["runEventTrigger"] = true
                  ? (() => {
                      const actionArgs = {
                        eventRef: $props["eventTrigger"],
                        args: [
                          "subTitle",
                          (() => {
                            try {
                              return $props.subTitle;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()
                        ]
                      };
                      return (({ eventRef, args }) => {
                        return eventRef?.(...(args ?? []));
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["runEventTrigger"] != null &&
                  typeof $steps["runEventTrigger"] === "object" &&
                  typeof $steps["runEventTrigger"].then === "function"
                ) {
                  $steps["runEventTrigger"] = await $steps["runEventTrigger"];
                }
              }}
              platform={"nextjs"}
              target={(() => {
                try {
                  return $props.url?.openInNewTab;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
              title={(() => {
                try {
                  return $props.url?.title;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
            >
              {(() => {
                try {
                  return !!$props.subTitle;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return false;
                  }
                  throw e;
                }
              })() ? (
                <LineClamp
                  className={classNames(
                    "__wab_instance",
                    sty.lineClamp___7VvD7,
                    {
                      [sty.lineClampexternalBookDesign___7VvD7HqYe]: hasVariant(
                        $state,
                        "externalBookDesign",
                        "externalBookDesign"
                      )
                    }
                  )}
                  numberOfLines={(() => {
                    try {
                      return !$props.rateCount ? 2 : 1;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return 1;
                      }
                      throw e;
                    }
                  })()}
                >
                  <TagsRow
                    className={classNames("__wab_instance", sty.tagsRow__kdQvn)}
                    items={(() => {
                      try {
                        return {
                          tags: $props.certificates.expertises.map(
                            cert => `${cert.degree.name} ${cert.expertise.name}`
                          )
                        };
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return undefined;
                        }
                        throw e;
                      }
                    })()}
                  />
                </LineClamp>
              ) : null}
            </PlasmicLink__>
          ) : null}
          {(() => {
            try {
              return (
                $props.title &&
                $props.keywordTags &&
                Object.keys($props.keywordTags.user_priority_1).length > 0
              );
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return false;
              }
              throw e;
            }
          })() ? (
            <PlasmicLink__
              data-plasmic-name={"linkTags"}
              data-plasmic-override={overrides.linkTags}
              className={classNames(projectcss.all, projectcss.a, sty.linkTags)}
              component={Link}
              href={(() => {
                try {
                  return $props.url?.destination.startsWith("/center/https")
                    ? $props.url?.destination.slice(8, -1)
                    : $props.url?.destination;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
              onClick={async event => {
                const $steps = {};

                $steps["runEventTrigger"] = true
                  ? (() => {
                      const actionArgs = {
                        eventRef: $props["eventTrigger"],
                        args: [
                          "subTitle",
                          (() => {
                            try {
                              return $props.subTitle;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()
                        ]
                      };
                      return (({ eventRef, args }) => {
                        return eventRef?.(...(args ?? []));
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["runEventTrigger"] != null &&
                  typeof $steps["runEventTrigger"] === "object" &&
                  typeof $steps["runEventTrigger"].then === "function"
                ) {
                  $steps["runEventTrigger"] = await $steps["runEventTrigger"];
                }
              }}
              platform={"nextjs"}
              target={(() => {
                try {
                  return $props.url?.openInNewTab;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
              title={(() => {
                try {
                  return $props.url?.title;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return undefined;
                  }
                  throw e;
                }
              })()}
            >
              {(() => {
                try {
                  return !!$props.subTitle;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return false;
                  }
                  throw e;
                }
              })() ? (
                <LineClamp
                  className={classNames(
                    "__wab_instance",
                    sty.lineClamp__k1Ixo,
                    {
                      [sty.lineClampexternalBookDesign__k1IxohqYe]: hasVariant(
                        $state,
                        "externalBookDesign",
                        "externalBookDesign"
                      )
                    }
                  )}
                  numberOfLines={(() => {
                    try {
                      return !$props.rateCount ? 2 : 1;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return 1;
                      }
                      throw e;
                    }
                  })()}
                >
                  <TagsRow
                    className={classNames("__wab_instance", sty.tagsRow__jtDwd)}
                    items={(() => {
                      try {
                        return {
                          tags: $props.keywordTags.user_priority_1.map(
                            tag => tag
                          )
                        };
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return undefined;
                        }
                        throw e;
                      }
                    })()}
                  />
                </LineClamp>
              ) : null}
            </PlasmicLink__>
          ) : null}
          {(() => {
            try {
              return !!+$props.rateCount;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return false;
              }
              throw e;
            }
          })() ? (
            <div
              className={classNames(projectcss.all, sty.freeBox__zf7Bm, {
                [sty.freeBox_5StarRatingMode3__5StarA__zf7BmfZd0]: hasVariant(
                  $state,
                  "_5StarRatingMode3",
                  "_5StarA"
                ),
                [sty.freeBoxexternalBookDesign__zf7BmHqYe]: hasVariant(
                  $state,
                  "externalBookDesign",
                  "externalBookDesign"
                )
              })}
            >
              <PlasmicIcon__
                PlasmicIconType={
                  hasVariant($state, "_5StarRatingMode3", "_5StarA")
                    ? Icon2Icon
                    : Icon7Icon
                }
                className={classNames(projectcss.all, sty.svg___4KelP, {
                  [sty.svg_5StarRatingMode3__5StarA___4KelPfZd0]: hasVariant(
                    $state,
                    "_5StarRatingMode3",
                    "_5StarA"
                  ),
                  [sty.svgexternalBookDesign___4KelPhqYe]: hasVariant(
                    $state,
                    "externalBookDesign",
                    "externalBookDesign"
                  )
                })}
                role={"img"}
              />

              <span
                className={classNames(
                  projectcss.all,
                  projectcss.span,
                  projectcss.__wab_text,
                  sty.span__zMlGi,
                  {
                    [sty.span_5StarRatingMode3__5StarA__zMlGifZd0]: hasVariant(
                      $state,
                      "_5StarRatingMode3",
                      "_5StarA"
                    )
                  }
                )}
              >
                {hasVariant($state, "_5StarRatingMode3", "_5StarA") ? (
                  <React.Fragment>
                    {(() => {
                      try {
                        return $props.satisfactionPercent % 20 === 0
                          ? $props.satisfactionPercent / 20
                          : ($props.satisfactionPercent / 20)
                              .toFixed(1)
                              .replace(".0", "");
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return " ";
                        }
                        throw e;
                      }
                    })()}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    {(() => {
                      try {
                        return $props.satisfactionPercent % 20 === 0
                          ? $props.satisfactionPercent / 20
                          : Math.round(($props.satisfactionPercent / 20) * 10) /
                              10;
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return " ";
                        }
                        throw e;
                      }
                    })()}
                  </React.Fragment>
                )}
              </span>
              <span
                className={classNames(
                  projectcss.all,
                  projectcss.span,
                  projectcss.__wab_text,
                  sty.span__qbAn4,
                  {
                    [sty.span_5StarRatingMode3__5StarA__qbAn4FZd0]: hasVariant(
                      $state,
                      "_5StarRatingMode3",
                      "_5StarA"
                    )
                  }
                )}
              >
                <React.Fragment>
                  {(() => {
                    try {
                      return `(${$props.rateCount} نظر)`;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return "(376 \u0646\u0638\u0631)";
                      }
                      throw e;
                    }
                  })()}
                </React.Fragment>
              </span>
            </div>
          ) : null}
        </div>
      </div>
      {(() => {
        try {
          return $props.address;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return false;
          }
          throw e;
        }
      })() ? (
        <div
          className={classNames(projectcss.all, sty.freeBox__rdT8C, {
            [sty.freeBoxexternalBookDesign__rdT8CHqYe]: hasVariant(
              $state,
              "externalBookDesign",
              "externalBookDesign"
            )
          })}
        >
          <LocationIcon
            className={classNames(projectcss.all, sty.svg__uyLb1)}
            role={"img"}
          />

          <LineClamp
            className={classNames("__wab_instance", sty.lineClamp__sDffa)}
          >
            <span
              data-plasmic-name={"cardAddressRow"}
              data-plasmic-override={overrides.cardAddressRow}
              className={classNames(
                projectcss.all,
                projectcss.span,
                projectcss.__wab_text,
                sty.cardAddressRow,
                {
                  [sty.cardAddressRow_5StarRatingMode3__5StarA]: hasVariant(
                    $state,
                    "_5StarRatingMode3",
                    "_5StarA"
                  ),
                  [sty.cardAddressRowexternalBookDesign]: hasVariant(
                    $state,
                    "externalBookDesign",
                    "externalBookDesign"
                  )
                }
              )}
            >
              <React.Fragment>
                {(() => {
                  try {
                    return (() => {
                      function cropStringAtDelimiter(
                        str,
                        maxLength = 30,
                        tolerance = 5
                      ) {
                        if (typeof str !== "string") return "";
                        if (str.length <= maxLength) return str;
                        const delimiters = [" ", ",", ";", "-"];

                        const start = Math.max(maxLength - tolerance, 0);
                        const end = Math.min(maxLength + tolerance, str.length);
                        let cutIndex = -1;
                        for (let i = maxLength; i >= start; i--) {
                          if (delimiters.includes(str[i])) {
                            cutIndex = i;
                            break;
                          }
                        }
                        if (cutIndex === -1) {
                          for (let i = maxLength; i <= end; i++) {
                            if (delimiters.includes(str[i])) {
                              cutIndex = i;
                              break;
                            }
                          }
                        }
                        if (cutIndex === -1) {
                          cutIndex = maxLength;
                        }
                        const cropped = str.slice(0, cutIndex);
                        return cropped + "...";
                      }
                      return cropStringAtDelimiter($props.address);
                    })();
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return "\u0627\u0633\u062a\u0627\u0646 \u0641\u0644\u0627\u0646\u060c \u0634\u0647\u0631\u060c \u0645\u0646\u0637\u0642\u0647\u060c \u0645\u062d\u0644\u0647 \u0641\u0644\u0627\u0646\u060c \u062e\u06cc\u0627\u0628\u0627\u0646 \u0627\u06cc\u06a9\u0633 \u060c \u06a9\u0648\u0686\u0647 \u0627\u06cc\u06af\u0631\u06af \u060c \u0633\u0627\u062e\u062a\u0645\u0627\u0646 \u0634\u062e\u0635\u06cc \u0632\u0627\u062f\u0647\u060c \u0637\u0628\u0642\u0647\u060c \u0648\u0627\u062d\u062f\u060c \u067e\u0644\u0627\u06a9 ";
                    }
                    throw e;
                  }
                })()}
              </React.Fragment>
            </span>
          </LineClamp>
        </div>
      ) : null}
      {(() => {
        try {
          return $props.price;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return false;
          }
          throw e;
        }
      })() ? (
        <div className={classNames(projectcss.all, sty.freeBox__ddsL)}>
          <MoneyIcon
            className={classNames(projectcss.all, sty.svg__oF6)}
            role={"img"}
          />

          <span
            data-plasmic-name={"cardPrice"}
            data-plasmic-override={overrides.cardPrice}
            className={classNames(
              projectcss.all,
              projectcss.span,
              projectcss.__wab_text,
              sty.cardPrice
            )}
          >
            <React.Fragment>
              {(() => {
                try {
                  return tomanSign($props.price);
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return "128,000 \u062a\u0648\u0645\u0627\u0646";
                  }
                  throw e;
                }
              })()}
            </React.Fragment>
          </span>
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text___57MCk
            )}
          >
            {"    "}
          </div>
        </div>
      ) : null}
      {(() => {
        try {
          return $props.badges.length > 0;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return false;
          }
          throw e;
        }
      })() ? (
        <div
          className={classNames(projectcss.all, sty.freeBox__sd0, {
            [sty.freeBoxexternalBookDesign__sd0HqYe]: hasVariant(
              $state,
              "externalBookDesign",
              "externalBookDesign"
            )
          })}
        >
          {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
            (() => {
              try {
                return $props.badges;
              } catch (e) {
                if (
                  e instanceof TypeError ||
                  e?.plasmicType === "PlasmicUndefinedDataError"
                ) {
                  return [];
                }
                throw e;
              }
            })()
          ).map((__plasmic_item_0, __plasmic_idx_0) => {
            const currentItem = __plasmic_item_0;
            const currentIndex = __plasmic_idx_0;
            return (() => {
              const child$Props = {
                body: (
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__aNeb4
                    )}
                  >
                    <React.Fragment>
                      {(() => {
                        try {
                          return currentItem.description;
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return "";
                          }
                          throw e;
                        }
                      })()}
                    </React.Fragment>
                  </div>
                ),
                className: classNames("__wab_instance", sty.dialog),
                key: currentIndex,
                onOpenChange: async (...eventArgs: any) => {
                  generateStateOnChangeProp($state, [
                    "dialog",
                    __plasmic_idx_0,
                    "open"
                  ]).apply(null, eventArgs);

                  if (
                    eventArgs.length > 1 &&
                    eventArgs[1] &&
                    eventArgs[1]._plasmic_state_init_
                  ) {
                    return;
                  }
                },
                open: generateStateValueProp($state, [
                  "dialog",
                  __plasmic_idx_0,
                  "open"
                ]),
                title: (
                  <div
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.text__qVzhr
                    )}
                  >
                    <React.Fragment>
                      {(() => {
                        try {
                          return currentItem.title;
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return "Dialog title";
                          }
                          throw e;
                        }
                      })()}
                    </React.Fragment>
                  </div>
                ),
                trigger: (
                  <Chip
                    data-plasmic-name={"badgesChip"}
                    data-plasmic-override={overrides.badgesChip}
                    className={classNames("__wab_instance", sty.badgesChip)}
                    color={(() => {
                      try {
                        return currentItem.type === "success"
                          ? "gray"
                          : currentItem.type === "info"
                            ? "blue"
                            : "";
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return "gray";
                        }
                        throw e;
                      }
                    })()}
                    content={(() => {
                      try {
                        return currentItem.title;
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return undefined;
                        }
                        throw e;
                      }
                    })()}
                    rounded={true}
                    showEndIcon={(() => {
                      try {
                        return !!currentItem.description;
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return true;
                        }
                        throw e;
                      }
                    })()}
                    showStartIcon={(() => {
                      try {
                        return Boolean(currentItem.icon);
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return true;
                        }
                        throw e;
                      }
                    })()}
                    size={"xSmall"}
                    slot={
                      <InfoIcon
                        className={classNames(projectcss.all, sty.svg___4AT6K)}
                        role={"img"}
                      />
                    }
                  >
                    {(() => {
                      try {
                        return currentItem.icon == "smile-icon";
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return true;
                        }
                        throw e;
                      }
                    })() ? (
                      <SmileIcon
                        className={classNames(projectcss.all, sty.svg__fj8S)}
                        role={"img"}
                      />
                    ) : null}
                    {(() => {
                      try {
                        return currentItem.icon == "forbidden-icon";
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return true;
                        }
                        throw e;
                      }
                    })() ? (
                      <CalendarIcon
                        className={classNames(projectcss.all, sty.svg__vdNz)}
                        role={"img"}
                      />
                    ) : null}
                    {(() => {
                      try {
                        return currentItem.icon == "clock-icon";
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return true;
                        }
                        throw e;
                      }
                    })() ? (
                      <ClockIcon
                        className={classNames(projectcss.all, sty.svg___2BpJ)}
                        role={"img"}
                      />
                    ) : null}
                  </Chip>
                )
              };

              initializePlasmicStates(
                $state,
                [
                  {
                    name: "dialog[].open",
                    initFunc: ({ $props, $state, $queries, $q }) => false
                  }
                ],
                [__plasmic_idx_0]
              );
              return (
                <Dialog
                  data-plasmic-name={"dialog"}
                  data-plasmic-override={overrides.dialog}
                  {...child$Props}
                />
              );
            })();
          })}
        </div>
      ) : null}
      {(() => {
        try {
          return (
            !!$props.actionButtons ||
            $props.recordType === "application.chatbot"
          );
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return true;
          }
          throw e;
        }
      })() ? (
        <div
          data-plasmic-name={"actionButtonsContainer"}
          data-plasmic-override={overrides.actionButtonsContainer}
          className={classNames(projectcss.all, sty.actionButtonsContainer, {
            [sty.actionButtonsContainer_5StarRatingMode3__5StarA]: hasVariant(
              $state,
              "_5StarRatingMode3",
              "_5StarA"
            )
          })}
        >
          {(() => {
            try {
              return (() => {
                const isSpecificDomain = new RegExp(
                  "paziresh24.com|plasmic.app"
                ).test(globalThis.location.hostname);
                const isOutline = $props.actionButtons?.[0]?.outline;
                const noTopTitle = !$props.actionButtons?.[0]?.top_title;
                return isSpecificDomain && isOutline && noTopTitle;
              })();
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return false;
              }
              throw e;
            }
          })() ? (
            <div className={classNames(projectcss.all, sty.freeBox__kHysu)}>
              <ApiRequest
                data-plasmic-name={"rismanActionBtn"}
                data-plasmic-override={overrides.rismanActionBtn}
                className={classNames("__wab_instance", sty.rismanActionBtn)}
                errorDisplay={null}
                loadingDisplay={
                  <div
                    className={classNames(projectcss.all, sty.freeBox___4XLvC)}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        sty.freeBox___5XDh0,
                        "skeleton-shimmer"
                      )}
                    />

                    <div
                      className={classNames(
                        projectcss.all,
                        sty.freeBox__sWa1I,
                        "skeleton-shimmer"
                      )}
                    />
                  </div>
                }
                method={"GET"}
                onError={async (...eventArgs: any) => {
                  generateStateOnChangeProp($state, [
                    "rismanActionBtn",
                    "error"
                  ]).apply(null, eventArgs);
                }}
                onLoading={async (...eventArgs: any) => {
                  generateStateOnChangeProp($state, [
                    "rismanActionBtn",
                    "loading"
                  ]).apply(null, eventArgs);
                }}
                onSuccess={async (...eventArgs: any) => {
                  generateStateOnChangeProp($state, [
                    "rismanActionBtn",
                    "data"
                  ]).apply(null, eventArgs);

                  (async data => {
                    const $steps = {};
                  }).apply(null, eventArgs);
                }}
                params={undefined}
                ref={ref => {
                  $refs["rismanActionBtn"] = ref;
                }}
                url={(() => {
                  try {
                    return `https://apigw.paziresh24.com/v1/risman/doctors/?doctor_id=${$props.searchCardId}`;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return undefined;
                    }
                    throw e;
                  }
                })()}
              >
                <div className={classNames(projectcss.all, sty.freeBox__l4Yi8)}>
                  {(() => {
                    try {
                      return !!$state.rismanActionBtn.data.data?.doctorId;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return false;
                      }
                      throw e;
                    }
                  })() ? (
                    <div
                      className={classNames(
                        projectcss.all,
                        sty.freeBox__obAvn,
                        {
                          [sty.freeBox_5StarRatingMode3__5StarA__obAvnfZd0]:
                            hasVariant($state, "_5StarRatingMode3", "_5StarA")
                        }
                      )}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__fFHu
                        )}
                      >
                        <Button
                          children2={
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__lvRrp
                              )}
                            >
                              {
                                "\u0645\u0634\u0627\u0647\u062f\u0647 \u0635\u0641\u062d\u0647"
                              }
                            </div>
                          }
                          className={classNames(
                            "__wab_instance",
                            sty.button__heg2
                          )}
                          endIcon={
                            <ChevronLeftIcon
                              className={classNames(
                                projectcss.all,
                                sty.svg__uEvbb
                              )}
                              role={"img"}
                            />
                          }
                          link={(() => {
                            try {
                              return viewPageLink({ slug: $props.slug, url: $props.url });
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                          onClick={async event => {
                            const $steps = {};

                            $steps["runEventTrigger"] = true
                              ? (() => {
                                  const actionArgs = {
                                    eventRef: $props["eventTrigger"],
                                    args: [
                                      "action-button",
                                      "\u0645\u0634\u0627\u0647\u062f\u0647 \u0635\u0641\u062d\u0647"
                                    ]
                                  };
                                  return (({ eventRef, args }) => {
                                    return eventRef?.(...(args ?? []));
                                  })?.apply(null, [actionArgs]);
                                })()
                              : undefined;
                            if (
                              $steps["runEventTrigger"] != null &&
                              typeof $steps["runEventTrigger"] === "object" &&
                              typeof $steps["runEventTrigger"].then ===
                                "function"
                            ) {
                              $steps["runEventTrigger"] =
                                await $steps["runEventTrigger"];
                            }
                          }}
                          outline={true}
                          startIcon={
                            <ChevronRightIcon
                              className={classNames(
                                projectcss.all,
                                sty.svg___6Utg6
                              )}
                              role={"img"}
                            />
                          }
                          target={true}
                        />
                      </div>
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__ecZdn
                        )}
                      >
                        {(() => {
                          try {
                            return $state.rismanActionBtn.data.data.destination[
                              "first-appointment"
                            ] !== null ||
                              $state.rismanActionBtn.data.data.destination[
                                "first-appointment"
                              ]
                              ? $state.rismanActionBtn.data.data.destination[
                                  "first-appointment"
                                ]
                              : false;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return false;
                            }
                            throw e;
                          }
                        })() ? (
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__lbCk
                            )}
                          >
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__e4VZc
                              )}
                            >
                              {
                                "\u0627\u0648\u0644\u06cc\u0646 \u0646\u0648\u0628\u062a: "
                              }
                            </div>
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__pAe1T
                              )}
                            >
                              <React.Fragment>
                                {(() => {
                                  try {
                                    return $state.rismanActionBtn.data.data
                                      .destination["first-appointment"];
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return "\u0627\u0648\u0644\u06cc\u0646 \u0646\u0648\u0628\u062a \u062e\u0627\u0644\u06cc: \u06f1\u06f5 \u0627\u0633\u0641\u0646\u062f \u06f1\u06f0:\u06f0\u06f0";
                                    }
                                    throw e;
                                  }
                                })()}
                              </React.Fragment>
                            </div>
                          </div>
                        ) : null}
                        <Button
                          children2={
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text___6Jtoh
                              )}
                            >
                              <React.Fragment>
                                {(() => {
                                  try {
                                    return $state.rismanActionBtn.data.data
                                      .destination["btn-text"];
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return "\u0633\u0627\u06cc\u062a \u062f\u06cc\u06af\u0631";
                                    }
                                    throw e;
                                  }
                                })()}
                              </React.Fragment>
                            </div>
                          }
                          className={classNames(
                            "__wab_instance",
                            sty.button__ihcOu
                          )}
                          endIcon={
                            <ChevronLeftIcon
                              className={classNames(
                                projectcss.all,
                                sty.svg__amGxa
                              )}
                              role={"img"}
                            />
                          }
                          link={(() => {
                            try {
                              return (
                                "https://risman-bridge.paziresh24.com/?source=search&provide=page&display_name=" +
                                $state.rismanActionBtn.data.data.fullName +
                                "&uri=" +
                                globalThis.encodeURIComponent(
                                  $state.rismanActionBtn.data.data.destination
                                    .url
                                ) +
                                "&platform=" +
                                $state.rismanActionBtn.data.data.destination
                                  .platform +
                                "&doctor_id=" +
                                $state.rismanActionBtn.data.data.doctorId
                              );
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                          onClick={async event => {
                            const $steps = {};

                            $steps["runEventTrigger"] = true
                              ? (() => {
                                  const actionArgs = {
                                    eventRef: $props["eventTrigger"],
                                    args: [
                                      "action-button",
                                      (() => {
                                        try {
                                          return (
                                            "risman_" +
                                            $state.rismanActionBtn.data.data
                                              .destination["btn-text"]
                                          );
                                        } catch (e) {
                                          if (
                                            e instanceof TypeError ||
                                            e?.plasmicType ===
                                              "PlasmicUndefinedDataError"
                                          ) {
                                            return undefined;
                                          }
                                          throw e;
                                        }
                                      })()
                                    ]
                                  };
                                  return (({ eventRef, args }) => {
                                    return eventRef?.(...(args ?? []));
                                  })?.apply(null, [actionArgs]);
                                })()
                              : undefined;
                            if (
                              $steps["runEventTrigger"] != null &&
                              typeof $steps["runEventTrigger"] === "object" &&
                              typeof $steps["runEventTrigger"].then ===
                                "function"
                            ) {
                              $steps["runEventTrigger"] =
                                await $steps["runEventTrigger"];
                            }
                          }}
                          outline={true}
                          startIcon={
                            <ChevronRightIcon
                              className={classNames(
                                projectcss.all,
                                sty.svg__aOe53
                              )}
                              role={"img"}
                            />
                          }
                          target={true}
                        />
                      </div>
                    </div>
                  ) : null}
                </div>
              </ApiRequest>
            </div>
          ) : null}
          {(() => {
            try {
              return $state.rismanActionBtn?.loading
                ? true
                : $props.actionButtons?.length > 1 ||
                    $props.actionButtons?.some?.(item => !item.outline) ||
                    !!$props.actionButtons?.some?.(item => item.top_title) ||
                    !!$state?.rismanActionBtn?.error ||
                    !$state.rismanActionBtn.data?.data?.doctorId;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return false;
              }
              throw e;
            }
          })() ? (
            <div className={classNames(projectcss.all, sty.freeBox__nvVzj)}>
              {(() => {
                try {
                  return $ctx.Growthbook.features["theme-config"][
                    "search_result:show_card_action_sdui_v2"
                  ]
                    ? true
                    : false;
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return false;
                  }
                  throw e;
                }
              })() ? (
                <ApiRequest
                  data-plasmic-name={"cardActionSduiV2UiRequest"}
                  data-plasmic-override={overrides.cardActionSduiV2UiRequest}
                  className={classNames(
                    "__wab_instance",
                    sty.cardActionSduiV2UiRequest
                  )}
                  config={(() => {
                    try {
                      return {
                        test: $props.searchCardId
                      };
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                  errorDisplay={
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__s4JDx
                      )}
                    >
                      <React.Fragment>
                        {(() => {
                          try {
                            return "بروز خطا در دریافت اطلاعات ";
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return "Error fetching data";
                            }
                            throw e;
                          }
                        })()}
                      </React.Fragment>
                    </div>
                  }
                  loadingDisplay={null}
                  method={"GET"}
                  onError={async (...eventArgs: any) => {
                    generateStateOnChangeProp($state, [
                      "cardActionSduiV2UiRequest",
                      "error"
                    ]).apply(null, eventArgs);
                  }}
                  onLoading={async (...eventArgs: any) => {
                    generateStateOnChangeProp($state, [
                      "cardActionSduiV2UiRequest",
                      "loading"
                    ]).apply(null, eventArgs);
                  }}
                  onSuccess={async (...eventArgs: any) => {
                    generateStateOnChangeProp($state, [
                      "cardActionSduiV2UiRequest",
                      "data"
                    ]).apply(null, eventArgs);

                    (async data => {
                      const $steps = {};
                    }).apply(null, eventArgs);
                  }}
                  params={undefined}
                  ref={ref => {
                    $refs["cardActionSduiV2UiRequest"] = ref;
                  }}
                  url={(() => {
                    try {
                      return `https://apisix-hmr-2.paziresh24.com/v1/ui-jahannama/search-result-card-ui/${$props.searchCardId}`;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return undefined;
                      }
                      throw e;
                    }
                  })()}
                >
                  {(() => {
                    try {
                      return (
                        $ctx.Growthbook.features["theme-config"][
                          "search_result:show_card_action_sdui_v2"
                        ] &&
                        $state.cardActionSduiV2UiRequest.data
                          .search_result_card_ui[0]?.data.actions?.length > 0
                      );
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return false;
                      }
                      throw e;
                    }
                  })() ? (
                    <div
                      className={classNames(
                        projectcss.all,
                        sty.freeBox__ybVvU,
                        {
                          [sty.freeBox_5StarRatingMode3__5StarA__ybVvUfZd0]:
                            hasVariant($state, "_5StarRatingMode3", "_5StarA")
                        }
                      )}
                    >
                      {(() => {
                        try {
                          return $state.cardActionSduiV2UiRequest.data
                            .search_result_card_ui[0]?.data?.actions
                            ? true
                            : false;
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return false;
                          }
                          throw e;
                        }
                      })()
                        ? (_par =>
                            !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                            (() => {
                              try {
                                return $state.cardActionSduiV2UiRequest.data
                                  .search_result_card_ui[0].data.actions;
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return [];
                                }
                                throw e;
                              }
                            })()
                          ).map((__plasmic_item_0, __plasmic_idx_0) => {
                            const actionButton = __plasmic_item_0;
                            const currentIndex = __plasmic_idx_0;
                            return (
                              <div
                                className={classNames(
                                  projectcss.all,
                                  sty.freeBox__mf4Qz
                                )}
                                key={currentIndex}
                              >
                                {(() => {
                                  try {
                                    return compactTopTitle(actionButton.top_title);
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return true;
                                    }
                                    throw e;
                                  }
                                })() ? (
                                  <span
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.span,
                                      projectcss.__wab_text,
                                      sty.span___0BetQ
                                    )}
                                  >
                                    <div
                                      className={
                                        projectcss.__wab_expr_html_text
                                      }
                                      dangerouslySetInnerHTML={{
                                        __html: (() => {
                                          try {
                                            return compactTopTitle(actionButton.top_title);
                                          } catch (e) {
                                            if (
                                              e instanceof TypeError ||
                                              e?.plasmicType ===
                                                "PlasmicUndefinedDataError"
                                            ) {
                                              return "";
                                            }
                                            throw e;
                                          }
                                        })()
                                      }}
                                    />
                                  </span>
                                ) : null}
                                <Button
                                  children2={
                                    <div
                                      className={classNames(
                                        projectcss.all,
                                        projectcss.__wab_text,
                                        sty.text__fuNx4
                                      )}
                                    >
                                      <React.Fragment>
                                        {(() => {
                                          try {
                                            return actionButton.title;
                                          } catch (e) {
                                            if (
                                              e instanceof TypeError ||
                                              e?.plasmicType ===
                                                "PlasmicUndefinedDataError"
                                            ) {
                                              return "Button";
                                            }
                                            throw e;
                                          }
                                        })()}
                                      </React.Fragment>
                                    </div>
                                  }
                                  className={classNames(
                                    "__wab_instance",
                                    sty.button__j7YzP
                                  )}
                                  endIcon={
                                    <ChevronLeftIcon
                                      className={classNames(
                                        projectcss.all,
                                        sty.svg__ptUpu
                                      )}
                                      role={"img"}
                                    />
                                  }
                                  link={(() => {
                                    try {
                                      return actionButton.url.startsWith(
                                        "/center/https"
                                      )
                                        ? actionButton.url.slice(8, -1)
                                        : actionButton.url;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return undefined;
                                      }
                                      throw e;
                                    }
                                  })()}
                                  onClick={async event => {
                                    const $steps = {};

                                    $steps["runEventTrigger"] = true
                                      ? (() => {
                                          const actionArgs = {
                                            eventRef: $props["eventTrigger"],
                                            args: [
                                              "action-button",
                                              (() => {
                                                try {
                                                  return actionButton.title;
                                                } catch (e) {
                                                  if (
                                                    e instanceof TypeError ||
                                                    e?.plasmicType ===
                                                      "PlasmicUndefinedDataError"
                                                  ) {
                                                    return undefined;
                                                  }
                                                  throw e;
                                                }
                                              })()
                                            ]
                                          };
                                          return (({ eventRef, args }) => {
                                            return eventRef?.(...(args ?? []));
                                          })?.apply(null, [actionArgs]);
                                        })()
                                      : undefined;
                                    if (
                                      $steps["runEventTrigger"] != null &&
                                      typeof $steps["runEventTrigger"] ===
                                        "object" &&
                                      typeof $steps["runEventTrigger"].then ===
                                        "function"
                                    ) {
                                      $steps["runEventTrigger"] =
                                        await $steps["runEventTrigger"];
                                    }
                                  }}
                                  outline={(() => {
                                    try {
                                      return actionButton.outline;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return [];
                                      }
                                      throw e;
                                    }
                                  })()}
                                  startIcon={
                                    <ChevronRightIcon
                                      className={classNames(
                                        projectcss.all,
                                        sty.svg__fAvHp
                                      )}
                                      role={"img"}
                                    />
                                  }
                                  target={false}
                                />
                              </div>
                            );
                          })
                        : null}
                    </div>
                  ) : null}
                </ApiRequest>
              ) : null}
              {(() => {
                try {
                  return (() => {
                    const isGrowthbookReady = $ctx.Growthbook?.isReady === true;
                    const areOldActionButtonsAvailable =
                      $props.actionButtons.length > 0;
                    const isNewSDUIActionsFeatureFlagEnabled =
                      $ctx.Growthbook?.features?.["theme-config"]?.[
                        "search_result:show_card_action_sdui_v2"
                      ] === true;
                    const isNewSDUIActionsDataAvailable =
                      $state.cardActionSduiV2UiRequest?.data
                        ?.search_result_card_ui?.[0]?.data?.actions?.length > 0;
                    return (
                      areOldActionButtonsAvailable &&
                      (!$ctx.Growthbook ||
                        !(
                          isGrowthbookReady &&
                          isNewSDUIActionsFeatureFlagEnabled &&
                          isNewSDUIActionsDataAvailable
                        ))
                    );
                  })();
                } catch (e) {
                  if (
                    e instanceof TypeError ||
                    e?.plasmicType === "PlasmicUndefinedDataError"
                  ) {
                    return false;
                  }
                  throw e;
                }
              })() ? (
                <div
                  data-plasmic-name={"oldActionButtonsHorizontalStack"}
                  data-plasmic-override={
                    overrides.oldActionButtonsHorizontalStack
                  }
                  className={classNames(
                    projectcss.all,
                    sty.oldActionButtonsHorizontalStack,
                    {
                      [sty.oldActionButtonsHorizontalStack_5StarRatingMode3__5StarA]:
                        hasVariant($state, "_5StarRatingMode3", "_5StarA")
                    }
                  )}
                >
                  {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
                    (() => {
                      try {
                        return $props.actionButtons;
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return [];
                        }
                        throw e;
                      }
                    })()
                  ).map((__plasmic_item_0, __plasmic_idx_0) => {
                    const actionButton = __plasmic_item_0;
                    const currentIndex = __plasmic_idx_0;
                    return (
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__xozVc
                        )}
                        key={currentIndex}
                      >
                        {(() => {
                          try {
                            return (() => {
                              if (
                                !$ctx.Growthbook ||
                                !$ctx.Growthbook.attributes?.url ||
                                !$ctx.Growthbook.isReady
                              ) {
                                return true;
                              } else if (
                                !!$ctx.Growthbook.features["theme-config"] &&
                                actionButton.top_title &&
                                actionButton.top_title.trim() !== "" &&
                                !$ctx.Growthbook.features["theme-config"][
                                  "search_result:first_free_time_data_src_from_availability-status_api"
                                ]
                              ) {
                                return true;
                              } else {
                                return false;
                              }
                            })();
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return false;
                            }
                            throw e;
                          }
                        })() ? (
                          <span
                            className={classNames(
                              projectcss.all,
                              projectcss.span,
                              projectcss.__wab_text,
                              sty.span__mY5Gg
                            )}
                          >
                            <div
                              className={projectcss.__wab_expr_html_text}
                              dangerouslySetInnerHTML={{
                                __html: (() => {
                                  try {
                                    return compactTopTitle(actionButton.top_title);
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return "";
                                    }
                                    throw e;
                                  }
                                })()
                              }}
                            />
                          </span>
                        ) : null}
                        {(() => {
                          try {
                            return (
                              $ctx.Growthbook.features["theme-config"][
                                "search_result:first_free_time_data_src_from_availability-status_api"
                              ] !== undefined &&
                              $ctx.Growthbook.features["theme-config"][
                                "search_result:first_free_time_data_src_from_availability-status_api"
                              ] === true
                            );
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return false;
                            }
                            throw e;
                          }
                        })() ? (
                          <div
                            className={classNames(
                              projectcss.all,
                              sty.freeBox__xzb64
                            )}
                          >
                            <ApiRequest
                              data-plasmic-name={
                                "getProviderFromSlugApiRequest"
                              }
                              data-plasmic-override={
                                overrides.getProviderFromSlugApiRequest
                              }
                              className={classNames(
                                "__wab_instance",
                                sty.getProviderFromSlugApiRequest
                              )}
                              errorDisplay={
                                <div
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.__wab_text,
                                    sty.text__lq4Dj
                                  )}
                                >
                                  <React.Fragment>
                                    {(() => {
                                      try {
                                        return "بروز خطا در دریافت اطلاعات ";
                                      } catch (e) {
                                        if (
                                          e instanceof TypeError ||
                                          e?.plasmicType ===
                                            "PlasmicUndefinedDataError"
                                        ) {
                                          return "Error fetching data";
                                        }
                                        throw e;
                                      }
                                    })()}
                                  </React.Fragment>
                                </div>
                              }
                              loadingDisplay={
                                <div
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.__wab_text,
                                    sty.text__c1SLh
                                  )}
                                >
                                  {"Loading..."}
                                </div>
                              }
                              method={"GET"}
                              onError={async (...eventArgs: any) => {
                                generateStateOnChangeProp($state, [
                                  "getProviderFromSlugApiRequest",
                                  __plasmic_idx_0,
                                  "error"
                                ]).apply(null, eventArgs);
                              }}
                              onLoading={async (...eventArgs: any) => {
                                generateStateOnChangeProp($state, [
                                  "getProviderFromSlugApiRequest",
                                  __plasmic_idx_0,
                                  "loading"
                                ]).apply(null, eventArgs);
                              }}
                              onSuccess={async (...eventArgs: any) => {
                                generateStateOnChangeProp($state, [
                                  "getProviderFromSlugApiRequest",
                                  __plasmic_idx_0,
                                  "data"
                                ]).apply(null, eventArgs);
                              }}
                              ref={ref => {
                                $refs["getProviderFromSlugApiRequest"] = ref;
                              }}
                              url={(() => {
                                try {
                                  return (
                                    "https://apigw.paziresh24.com/v1/providers?slug=" +
                                    $props.slug
                                  );
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return undefined;
                                  }
                                  throw e;
                                }
                              })()}
                            >
                              <ApiRequest
                                data-plasmic-name={"availabilityStatus"}
                                data-plasmic-override={
                                  overrides.availabilityStatus
                                }
                                className={classNames(
                                  "__wab_instance",
                                  sty.availabilityStatus
                                )}
                                errorDisplay={
                                  <div
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.__wab_text,
                                      sty.text__utvuQ
                                    )}
                                  >
                                    <React.Fragment>
                                      {(() => {
                                        try {
                                          return "بروز خطا در دریافت اطلاعات ";
                                        } catch (e) {
                                          if (
                                            e instanceof TypeError ||
                                            e?.plasmicType ===
                                              "PlasmicUndefinedDataError"
                                          ) {
                                            return "Error fetching data";
                                          }
                                          throw e;
                                        }
                                      })()}
                                    </React.Fragment>
                                  </div>
                                }
                                loadingDisplay={
                                  <div
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.__wab_text,
                                      sty.text__emhrt
                                    )}
                                  >
                                    {"Loading..."}
                                  </div>
                                }
                                method={"GET"}
                                onError={async (...eventArgs: any) => {
                                  generateStateOnChangeProp($state, [
                                    "availabilityStatus",
                                    __plasmic_idx_0,
                                    "error"
                                  ]).apply(null, eventArgs);
                                }}
                                onLoading={async (...eventArgs: any) => {
                                  generateStateOnChangeProp($state, [
                                    "availabilityStatus",
                                    __plasmic_idx_0,
                                    "loading"
                                  ]).apply(null, eventArgs);
                                }}
                                onSuccess={async (...eventArgs: any) => {
                                  generateStateOnChangeProp($state, [
                                    "availabilityStatus",
                                    __plasmic_idx_0,
                                    "data"
                                  ]).apply(null, eventArgs);
                                }}
                                ref={ref => {
                                  $refs["availabilityStatus"] = ref;
                                }}
                                url={(() => {
                                  try {
                                    return (
                                      "https://apigw.paziresh24.com/core-booking/v1/providers/" +
                                      $state.getProviderFromSlugApiRequest[
                                        currentIndex
                                      ].data.providers[0].user_id +
                                      "/availability-status"
                                    );
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return undefined;
                                    }
                                    throw e;
                                  }
                                })()}
                              >
                                <span
                                  className={classNames(
                                    projectcss.all,
                                    projectcss.span,
                                    projectcss.__wab_text,
                                    sty.span__dqNWz
                                  )}
                                >
                                  <div
                                    className={projectcss.__wab_expr_html_text}
                                    dangerouslySetInnerHTML={{
                                      __html: (() => {
                                        try {
                                          return (() => {
                                            const centerIds =
                                              $props.centers.map(
                                                center => center.id
                                              );
                                            const availabilities =
                                              $state.availabilityStatus[
                                                currentIndex
                                              ].data.availability;
                                            const filteredAvailabilities =
                                              availabilities.filter(
                                                availability =>
                                                  centerIds.includes(
                                                    availability.center_id
                                                  )
                                              );
                                            if (
                                              filteredAvailabilities.length > 0
                                            ) {
                                              const nearestAvailability =
                                                filteredAvailabilities.reduce(
                                                  (earliest, current) =>
                                                    new Date(current.freeturn) <
                                                    new Date(earliest.freeturn)
                                                      ? current
                                                      : earliest
                                                );
                                              const presence_freeturn =
                                                new Date(
                                                  nearestAvailability.freeturn
                                                );
                                              const now = new Date();
                                              const timeDifference =
                                                (presence_freeturn - now) /
                                                1000;
                                              const formatTimeToFarsi =
                                                timeDifference => {
                                                  if (timeDifference <= 0) {
                                                    return "هم‌اکنون";
                                                  } else if (
                                                    timeDifference < 3600
                                                  ) {
                                                    return "کمتر از ۱ ساعت دیگر";
                                                  } else if (
                                                    timeDifference < 86400
                                                  ) {
                                                    const hours = Math.floor(
                                                      timeDifference / 3600
                                                    );
                                                    return `حدود ${hours} ساعت دیگر`;
                                                  } else {
                                                    const days = Math.floor(
                                                      timeDifference / 86400
                                                    );
                                                    return `حدود ${days} روز دیگر`;
                                                  }
                                                };
                                              const timeText =
                                                formatTimeToFarsi(
                                                  timeDifference
                                                );
                                              const inPersonTopTitle = `<span>اولین نوبت: <b>${timeText}</b></span>`;
                                              return compactTopTitle(inPersonTopTitle);
                                            } else {
                                              return null;
                                            }
                                          })();
                                        } catch (e) {
                                          if (
                                            e instanceof TypeError ||
                                            e?.plasmicType ===
                                              "PlasmicUndefinedDataError"
                                          ) {
                                            return "";
                                          }
                                          throw e;
                                        }
                                      })()
                                    }}
                                  />
                                </span>
                              </ApiRequest>
                            </ApiRequest>
                          </div>
                        ) : null}
                        <Button
                          children2={
                            <React.Fragment>
                              {(() => {
                                try {
                                  return actionButton.title;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return "Button";
                                  }
                                  throw e;
                                }
                              })()}
                            </React.Fragment>
                          }
                          className={classNames(
                            "__wab_instance",
                            sty.button__kYXz,
                            {
                              [sty.button_5StarRatingMode3__5StarA__kYXzfZd0]:
                                hasVariant(
                                  $state,
                                  "_5StarRatingMode3",
                                  "_5StarA"
                                )
                            }
                          )}
                          endIcon={
                            <ChevronLeftIcon
                              className={classNames(
                                projectcss.all,
                                sty.svg__b1Zmp
                              )}
                              role={"img"}
                            />
                          }
                          link={
                            hasVariant(globalVariants, "screen", "mobileOnly")
                              ? (() => {
                                  try {
                                    return (() => {
                                      if (
                                        actionButton.title === "ویزیت آنلاین" &&
                                        $props.actionButtons[0].url
                                          .split("/")
                                          .slice(-2, -1)[0].length == 36 &&
                                        $ctx.Growthbook.features[
                                          "search-online-visit-factor-modal"
                                        ]?.includes?.($props.slug)
                                      ) {
                                        return "";
                                      }
                                      return actionButton.url.startsWith(
                                        "/center/https"
                                      )
                                        ? actionButton.url.slice(8, -1)
                                        : actionButton.url;
                                    })();
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return undefined;
                                    }
                                    throw e;
                                  }
                                })()
                              : (() => {
                                  try {
                                    return actionButton.url.startsWith(
                                      "/center/https"
                                    )
                                      ? actionButton.url.slice(8, -1)
                                      : actionButton.url;
                                  } catch (e) {
                                    if (
                                      e instanceof TypeError ||
                                      e?.plasmicType ===
                                        "PlasmicUndefinedDataError"
                                    ) {
                                      return undefined;
                                    }
                                    throw e;
                                  }
                                })()
                          }
                          onClick={async event => {
                            const $steps = {};

                            $steps["runEventTrigger"] = true
                              ? (() => {
                                  const actionArgs = {
                                    eventRef: $props["eventTrigger"],
                                    args: [
                                      "action-button",
                                      (() => {
                                        try {
                                          return actionButton.title;
                                        } catch (e) {
                                          if (
                                            e instanceof TypeError ||
                                            e?.plasmicType ===
                                              "PlasmicUndefinedDataError"
                                          ) {
                                            return undefined;
                                          }
                                          throw e;
                                        }
                                      })()
                                    ]
                                  };
                                  return (({ eventRef, args }) => {
                                    return eventRef?.(...(args ?? []));
                                  })?.apply(null, [actionArgs]);
                                })()
                              : undefined;
                            if (
                              $steps["runEventTrigger"] != null &&
                              typeof $steps["runEventTrigger"] === "object" &&
                              typeof $steps["runEventTrigger"].then ===
                                "function"
                            ) {
                              $steps["runEventTrigger"] =
                                await $steps["runEventTrigger"];
                            }
                          }}
                          outline={(() => {
                            try {
                              return actionButton.outline;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return [];
                              }
                              throw e;
                            }
                          })()}
                          startIcon={
                            <ChevronRightIcon
                              className={classNames(
                                projectcss.all,
                                sty.svg__dDPe
                              )}
                              role={"img"}
                            />
                          }
                        />
                      </div>
                    );
                  })}
                </div>
              ) : null}
            </div>
          ) : null}
        </div>
      ) : null}
      {(() => {
        try {
          return Object.keys($props.debugModeResult).length > 2;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return false;
          }
          throw e;
        }
      })() ? (
        <div className={classNames(projectcss.all, sty.freeBox__pV4)}>
          <div className={classNames(projectcss.all, sty.freeBox___7UCt)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__bz8I
              )}
            >
              <React.Fragment>
                {(() => {
                  try {
                    return $props.debugModeResult.indexName;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return "";
                    }
                    throw e;
                  }
                })()}
              </React.Fragment>
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__yzXdY
              )}
            >
              <React.Fragment>
                {(() => {
                  try {
                    return $props.debugModeResult.documentId;
                  } catch (e) {
                    if (
                      e instanceof TypeError ||
                      e?.plasmicType === "PlasmicUndefinedDataError"
                    ) {
                      return "";
                    }
                    throw e;
                  }
                })()}
              </React.Fragment>
            </div>
          </div>
          <div className={classNames(projectcss.all, sty.freeBox__u1Q0)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text___7Gyd
              )}
            >
              <div
                className={projectcss.__wab_expr_html_text}
                dangerouslySetInnerHTML={{
                  __html: (() => {
                    try {
                      return Object.entries($props.debugModeResult.documentInfo)
                        .map(([key, value]) => `${key}: ${value}`)
                        .join("<br>");
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return "";
                      }
                      throw e;
                    }
                  })()
                }}
              />
            </div>
          </div>
        </div>
      ) : null}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "avatar",
    "classificationTitle",
    "badgesChip2",
    "cardTitle",
    "linkSubtitle",
    "cardSubtitle",
    "linkTagsOfExpertise",
    "linkTags",
    "cardAddressRow",
    "cardPrice",
    "dialog",
    "badgesChip",
    "actionButtonsContainer",
    "rismanActionBtn",
    "cardActionSduiV2UiRequest",
    "oldActionButtonsHorizontalStack",
    "getProviderFromSlugApiRequest",
    "availabilityStatus"
  ],
  avatar: ["avatar"],
  classificationTitle: ["classificationTitle", "badgesChip2"],
  badgesChip2: ["badgesChip2"],
  cardTitle: ["cardTitle"],
  linkSubtitle: ["linkSubtitle", "cardSubtitle"],
  cardSubtitle: ["cardSubtitle"],
  linkTagsOfExpertise: ["linkTagsOfExpertise"],
  linkTags: ["linkTags"],
  cardAddressRow: ["cardAddressRow"],
  cardPrice: ["cardPrice"],
  dialog: ["dialog", "badgesChip"],
  badgesChip: ["badgesChip"],
  actionButtonsContainer: [
    "actionButtonsContainer",
    "rismanActionBtn",
    "cardActionSduiV2UiRequest",
    "oldActionButtonsHorizontalStack",
    "getProviderFromSlugApiRequest",
    "availabilityStatus"
  ],
  rismanActionBtn: ["rismanActionBtn"],
  cardActionSduiV2UiRequest: ["cardActionSduiV2UiRequest"],
  oldActionButtonsHorizontalStack: [
    "oldActionButtonsHorizontalStack",
    "getProviderFromSlugApiRequest",
    "availabilityStatus"
  ],
  getProviderFromSlugApiRequest: [
    "getProviderFromSlugApiRequest",
    "availabilityStatus"
  ],
  availabilityStatus: ["availabilityStatus"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  avatar: typeof Avatar;
  classificationTitle: "span";
  badgesChip2: typeof Chip;
  cardTitle: "h2";
  linkSubtitle: "a";
  cardSubtitle: "span";
  linkTagsOfExpertise: "a";
  linkTags: "a";
  cardAddressRow: "span";
  cardPrice: "span";
  dialog: typeof Dialog;
  badgesChip: typeof Chip;
  actionButtonsContainer: "div";
  rismanActionBtn: typeof ApiRequest;
  cardActionSduiV2UiRequest: typeof ApiRequest;
  oldActionButtonsHorizontalStack: "div";
  getProviderFromSlugApiRequest: typeof ApiRequest;
  availabilityStatus: typeof ApiRequest;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicProductCard__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicProductCard__VariantsArgs;
    args?: PlasmicProductCard__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicProductCard__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicProductCard__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicProductCard__ArgProps,
          internalVariantPropNames: PlasmicProductCard__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicProductCard__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicProductCard";
  } else {
    func.displayName = `PlasmicProductCard.${nodeName}`;
  }
  return func;
}

export const PlasmicProductCard = Object.assign(
  // Top-level PlasmicProductCard renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    avatar: makeNodeComponent("avatar"),
    classificationTitle: makeNodeComponent("classificationTitle"),
    badgesChip2: makeNodeComponent("badgesChip2"),
    cardTitle: makeNodeComponent("cardTitle"),
    linkSubtitle: makeNodeComponent("linkSubtitle"),
    cardSubtitle: makeNodeComponent("cardSubtitle"),
    linkTagsOfExpertise: makeNodeComponent("linkTagsOfExpertise"),
    linkTags: makeNodeComponent("linkTags"),
    cardAddressRow: makeNodeComponent("cardAddressRow"),
    cardPrice: makeNodeComponent("cardPrice"),
    dialog: makeNodeComponent("dialog"),
    badgesChip: makeNodeComponent("badgesChip"),
    actionButtonsContainer: makeNodeComponent("actionButtonsContainer"),
    rismanActionBtn: makeNodeComponent("rismanActionBtn"),
    cardActionSduiV2UiRequest: makeNodeComponent("cardActionSduiV2UiRequest"),
    oldActionButtonsHorizontalStack: makeNodeComponent(
      "oldActionButtonsHorizontalStack"
    ),
    getProviderFromSlugApiRequest: makeNodeComponent(
      "getProviderFromSlugApiRequest"
    ),
    availabilityStatus: makeNodeComponent("availabilityStatus"),

    // Metadata about props expected for PlasmicProductCard
    internalVariantProps: PlasmicProductCard__VariantProps,
    internalArgProps: PlasmicProductCard__ArgProps
  }
);

export default PlasmicProductCard;
/* prettier-ignore-end */
